import React, { useContext } from 'react';
import { NavLink } from 'react-router-dom';
import Menu from '@isomorphic/shared/UIView/Antd/Menu/Menu';
import { AuthContext } from '../../../context/AuthProvider';
import {
  HOME_PAGE,
  LISTING_POSTS_PAGE,
  PRICING_PLAN_PAGE,
   ADD_HOTEL_PAGE,
  AGENT_ACCOUNT_SETTINGS_PAGE,
  AGENT_PROFILE_PAGE,
  AGENT_PROFILE_CONTACT,
} from '../../../settings/constant';

const MobileMenu = ({ className }) => {
  // auth context
  const { loggedIn, logOut } = useContext(AuthContext);

  return (
    <Menu className={className}>
     <Menu.Item key="0">
        <NavLink exact to={`${HOME_PAGE}`}>
          Accueil
        </NavLink>
      </Menu.Item>
   
      <Menu.Item key="2">
        <NavLink to={`${ADD_HOTEL_PAGE}`}>Estimer la valeur d'un bien</NavLink>
      </Menu.Item>

      <Menu.Item key="3">
      <a href="http://ziaway.info" target="_blank">Blog</a>
      </Menu.Item>
      <Menu.Item key="4">
        <NavLink to={`${AGENT_PROFILE_CONTACT}`}>Nous contacter</NavLink>
      </Menu.Item>
   
      {loggedIn && (
        <Menu.Item key="6">
          <NavLink to={AGENT_ACCOUNT_SETTINGS_PAGE}>Mon compte</NavLink>
        </Menu.Item>
      )}
      {loggedIn && (
        <Menu.Item key="7">
          <button onClick={logOut}>Déconnexion</button>
        </Menu.Item>
      )}
    </Menu>
  );
};

export default MobileMenu;
